import React, { useEffect, useState } from "react";
import "./SingleProductDetails.css";
import WishListIcon from "../WishlistIcon/WishListIcon";
import ColorBlocks from "../ColorBlocks/ColorBlocks";
import ServicesCard from "../ServicesCard/ServicesCard";
import { ArrowUUpLeft, Lock, Phone, WarningCircle } from "phosphor-react";
import { useDispatch, useSelector } from "react-redux";
import { updateUserCart } from "../../appState/slices/cart/cartSlice";
import { setToastMessage } from "../../appState/slices/util/utilSlice";
import YouMayAlsoLike from "./YouMayAlsoLinke";
import { Col, List, Row } from "reactstrap";
import QualityBlock from "../QualityBlock/QualityBlock";
import { getCustomizedDetails, resetCustomizedDetails } from "../../appState/slices/product/productSlice";
import { useNavigate } from "react-router-dom";
import { addToGuestCart } from "../../utils/guestCart";
import { set } from "date-fns";

const SingleProductDetails = ({ setImageColor, productDetail }) => {
  const dispatch = useDispatch();
  const customizedDetails = useSelector((state) => state.product.customizeddetails) || {};
  const availableColors = productDetail?.colors || [];
  const currentPurity = productDetail?.purity || "";
  const currentQuality = productDetail?.diamondquality || "";
  const currentType = productDetail?.diamondtype || "";
  const [availableQualities, setAvailableQuality] = useState(productDetail?.availablequalities || []);
  const availablePurities = productDetail?.availablepurities || [];
  const availableRingSizes = productDetail?.availableringsizes || [];
  const [selectedType, setSelectedType] = useState(currentType);
  const [selectedColor, setSelectedColor] = useState(availableColors[0] || "Yellow");
  const [selectedQuality, setSelectedQuality] = useState(currentQuality);
  const [selectedPrice, setSelectedPrice] = useState(productDetail?.defaultPrice);
  const [selectedPurity, setSelectedPurity] = useState(currentPurity);
  const [selectedRingSize, setSelectedRingSize] = useState("");
  const [openPanel, setOpenPanel] = useState(null);
  const user = useSelector((state) => state.auth.user);
  const navigate = useNavigate();
  useEffect(() => {
    if (setImageColor && selectedColor) setImageColor(selectedColor);
  }, [selectedColor, setImageColor]);

  useEffect(() => {
    if (currentType) {
      setSelectedType(currentType);
    }
  }, [currentType]);



  const handleColorSelect = (color) => setSelectedColor(color);

  const handleQualitySelect = async (quality) => {
    setSelectedQuality(quality);
    dispatch(
      getCustomizedDetails({
        purity: selectedPurity, // ✅ use the new value
        diamondquality: quality,
        ringsize: selectedRingSize,
        productId: productDetail._id,
        diamondtype: selectedType,
      })
    );
  }

  const handleTypeSelect = async (type) => {
    setSelectedType(type);
    dispatch(
      getCustomizedDetails({
        diamondtype: type,
        purity: selectedPurity, // ✅ use the new value
        diamondquality: selectedQuality,
        ringsize: selectedRingSize,
        productId: productDetail._id,
      })
    );
  }

  const handleRingSizeSelect = async (ringsize) => {
    setSelectedRingSize(ringsize);
    dispatch(
      getCustomizedDetails({
        purity: selectedPurity, // ✅ use the new value
        diamondquality: selectedQuality,
        ringsize: ringsize,
        diamondtype: selectedType,
        productId: productDetail._id,
      })
    );
  }

  const handlePuritySelect = async (purity) => {
    setSelectedPurity(purity);
    await dispatch(
      getCustomizedDetails({
        purity, // ✅ use the new value
        diamondquality: selectedQuality,
        ringsize: selectedRingSize,
        productId: productDetail._id,
        diamondtype: selectedType,
      })
    );
  };

  useEffect(() => {
    const arr =
      productDetail?.availablequalities?.filter(
        (q) => q.type === selectedType
      ) || [];
    setAvailableQuality(arr);
    if (currentType !== selectedType) {
      if (arr.length > 0) {
        handleQualitySelect(arr[0].quality);
      }
    }

  }, [selectedType])

  useEffect(() => {
    if (customizedDetails?.totalAmount) {
      setSelectedPrice(customizedDetails.totalAmount);
    }
  }, [customizedDetails]);

  useEffect(() => {
    if (!productDetail?._id) return;

    dispatch(resetCustomizedDetails());
    setSelectedPurity(productDetail.purity);
    setSelectedQuality(productDetail.diamondquality);

    // ✅ set default ring size
    if (productDetail?.availableringsizes?.length > 0) {
      setSelectedRingSize(productDetail.ringsize);
    }

  }, [productDetail._id]);



  const togglePanel = (panel) => {
    setOpenPanel(openPanel === panel ? null : panel);
  };

  const addToBag = () => {

    if (user) {
      dispatch(
        updateUserCart({
          product: productDetail._id,
          color: selectedColor,
          quantity: 1,
          diamondtype: selectedType,
          ringsize: selectedRingSize,
          purity: selectedPurity,
          quality: selectedQuality,
          operation: "add",
        })
      );

      dispatch(
        setToastMessage({
          type: "done",
          show: true,
          itemmodal: true,
          product: productDetail,
          ringsize: selectedRingSize,
          price: selectedPrice,
          color: selectedColor,
          purity: selectedPurity,
          quality: selectedQuality,
          diamondtype: selectedType,
          timeout: 9000,
        })
      );
    }

    else {
      const currentUrl =
        window.location.pathname + window.location.search;

      localStorage.setItem(
        "redirectAfterLogin",
        currentUrl
      );

      navigate("/login");
    }
  };

  // 🧠 Define accordion panels dynamically
  const panels = [
    {
      title: "Product Details",
      show: productDetail.purity || productDetail.grosswt,
      content: (
        <>
          {productDetail.purity && <p><span className="proddetails-label">Purity:</span> <strong>{productDetail.purity}</strong></p>}
          <p><span className="proddetails-label">Total Gold Amount:</span> <strong>₹{customizedDetails.goldValue?.toFixed(0) || productDetail.totalgoldAmount?.toFixed(0)}</strong></p>
          {/* {productDetail.grosswt && <p><span className="proddetails-label">Product Weight:</span> <strong>{productDetail.inStock && selectedQuality === currentQuality && selectedType === currentType && selectedPurity === currentPurity ? (customizedDetails.grossWeight ?? productDetail.grosswt)?.toFixed(3) : "approx " + (customizedDetails.grossWeight ?? productDetail.grosswt)?.toFixed(3) } gm</strong></p>} */}
          {productDetail.netwt && <p><span className="proddetails-label">Gold Weight:</span> <strong>{productDetail.inStock && selectedQuality === currentQuality && selectedType === currentType && selectedPurity === currentPurity ? (customizedDetails.goldWeight ?? productDetail.netwt)?.toFixed(3) : "approx " + (customizedDetails.goldWeight ?? productDetail.netwt)?.toFixed(3)} gm</strong></p>}
          {/* {productDetail.netwt && <p><span className="proddetails-label">Gold Weight:</span> <strong>{(customizedDetails.goldWeight ?? productDetail.netwt)?.toFixed(3)} gm</strong></p>} */}
          {productDetail.totalMaking && <p><span className="proddetails-label">Making Charges: ₹</span> <strong>{(customizedDetails.makingChargeAfterDiscount ?? productDetail.totalMaking)?.toFixed(0)}</strong></p>}
        </>
      ),
    },
    {
      title: "Diamond Details",
      show: productDetail.diamonddetails?.length > 0,
      content: (
        <>
          {productDetail.totaldiamondweight && (
            <>
              <p><span className="proddetails-label">Total Diamond Weight:</span> <strong>{productDetail.totaldiamondweight} ct</strong></p>
              <p><span className="proddetails-label">Total Diamond Amount:</span> <strong>₹{customizedDetails.totalDiamondAmount?.toFixed(0) || productDetail.totalDiamondAmount?.toFixed(0)}</strong></p>
            </>
          )}
          <div className="details-grid">
            <Row>
              {productDetail.diamonddetails?.map((d, i) => (
                <Col xs="6" sm="6" md="4" lg="4" key={i}>
                  <div className="detail-card">
                    <span>{d.shape}</span>
                    <p>{d.carat} ct · {d.pieces} pcs</p>
                  </div>
                </Col>
              ))}
            </Row>
          </div>
        </>
      ),
    },
    {
      title: "Solitaire Details",
      show: productDetail.solitairedetails?.length > 0,
      content: (
        <div className="details-grid">
          {productDetail.solitairedetails?.map((s, i) => (
            <div key={i} className="detail-card">
              <span>✨ {s.shape}</span>
              <p>{s.quality}</p>
              <p>{s.carat} ct · {s.pieces} pcs</p>
            </div>
          ))}
        </div>
      ),
    },
    {
      title: "Stone Details",
      show: productDetail.stonedetails?.length > 0,
      content: (
        <div className="details-grid">
          {productDetail.stonedetails?.map((s, i) => (
            <div key={i} className="detail-card">
              {/* <span>🪶 {s.quality}</span> */}
              <p>{s.carat} ct · ₹{s.rate} · {s.pieces} pcs</p>
            </div>
          ))}
        </div>
      ),
    },
    {
      title: "Certificate",
      show: !!productDetail.certiname,
      content: (
        <p>
          <strong>{productDetail.certiname}</strong> — {productDetail.certino}
        </p>
      ),
    },
  ].filter((panel) => panel.show); // ✅ Only include those with real data

  return (
    <div>
      <div className="singleproduct-details">
        {/* 🟢 Header & Wishlist */}
        <div className="heading">
          <div className="product-headings">
            <h1 className="product-header font-bold t1">{productDetail.name}</h1>
          </div>
          <div className="heartcontainer">
            {
              user ?
                <WishListIcon
                  isWishlist={productDetail?.isWishlist}
                  id={productDetail._id}
                  pagename="singleproduct"
                  size="25"
                />
                :
                null
            }

          </div>
        </div>

        {/* 🟡 Description */}
        {productDetail.description && (
          <h4 className="proddetails-description font-semibold t6">{productDetail?.description}</h4>
        )}

        {/* 💰 Price Section */}
        {productDetail.discountPercentage ? (
          <div className="singleproduct-price">
            <h1 className="product-header font-bold t1 canceledprice">₹ {productDetail.mrp}</h1>
            <h1 className="product-header font-bold t1">₹ {customizedDetails.totalAmount || productDetail.defaultPrice} <span className="exgst">(excl GST)</span></h1>
          </div>
        ) : (
          <h1 className="product-header font-bold t1">₹ {customizedDetails.totalAmount || productDetail.defaultPrice} <span className="exgst">(excl GST)</span></h1>
        )}


        {/* 🎨 Color Options */}
        {availableColors.length > 0 && (
          <div className="colorcontainer">
            {availableColors.map((color, index) => (
              <div
                key={index}
                className={`${color === selectedColor ? "quickadd-selected-color" : ""}`}
                onClick={() => handleColorSelect(color)}
              >
                <ColorBlocks name={color} />
              </div>
            ))}
          </div>
        )}

        {/*  Purity Options */}
        {availablePurities?.length > 0 && (
          <div className="colorcontainer">
            {availablePurities?.map((purity, index) => (
              <div
                key={index}
                className={`${purity.purity === selectedPurity ? "qualityselected" : ""}`}
                onClick={() => handlePuritySelect(purity.purity)}
              >
                <QualityBlock quality={purity.purity} />
              </div>
            ))}
          </div>
        )}

        {/*  Type Options */}
        <div className="colorcontainer">
          {productDetail.typeavaibility?.natural ?
            <div
              key="natural"
              className={`${selectedType === "natural" ? "qualityselected" : ""}`}
              onClick={() => handleTypeSelect("natural")}
            >
              <QualityBlock quality="Natural" />
            </div>
            :
            null
          }
          {productDetail.typeavaibility?.lgd ?
            <div
              key="lab grown"
              className={`${selectedType === "lab grown" ? "qualityselected" : ""}`}
              onClick={() => handleTypeSelect("lab grown")}
            >
              <QualityBlock quality="Lab Grown" />
            </div>
            :
            null
          }
        </div>


        {/*  Quality Options */}

        {productDetail.diamonddetails?.length > 0 && availableQualities?.length > 0 && (
          <div className="colorcontainer">
            {availableQualities?.map((quality, index) => (
              <div
                key={index}
                className={`${quality.quality === selectedQuality ? "qualityselected" : ""}`}
                onClick={() => handleQualitySelect(quality.quality)}
              >
                <QualityBlock quality={quality.quality} />
              </div>
            ))}
          </div>
        )}

        {/* 💍 Ring Size Dropdown */}
        {productDetail?.categories?.find(c => c.name === "Rings") &&
          availableRingSizes?.length > 0 && (
            <div className="ringsize-container" style={{ marginTop: "10px" }}>
              <label className="proddetails-label">Select Ring Size:</label>

              <select
                value={selectedRingSize}
                onChange={(e) => handleRingSizeSelect(e.target.value)}
                className="ringsize-dropdown"
                style={{
                  width: "100%",
                  marginTop: "5px",
                }}
              >
                {availableRingSizes.map((size, index) => (
                  <option key={index} value={size}>
                    {size}
                  </option>
                ))}
              </select>
            </div>
          )}
        {productDetail.inStock ? (
  <>
    {selectedQuality === currentQuality &&
    selectedType === currentType &&
    selectedPurity === currentPurity ? (
      <div>Delivery in 5 - 7 Days</div>
    ) : (
      <>
      <div>
        Delivery in {productDetail.categories?.[0]?.expectedDeliveryDays} -{" "}
        {productDetail.categories?.[0]?.expectedDeliveryDays + 3} Days
      </div>
       <div className="details-change-warning">
      <span>
        <WarningCircle size={20} />
      </span>
      <span>
        &nbsp;The final product's gold, diamond, and stone weights may vary
        slightly. If the actual weight is less than the mentioned weight, a
        refund will be issued. If it is higher, the difference will be
        payable.
      </span>
    </div>
      </>
    )}

   
  </>
) : (
  <>
    <div>
      Delivery in {productDetail.categories?.[0]?.expectedDeliveryDays} -{" "}
      {productDetail.categories?.[0]?.expectedDeliveryDays + 3} Days
    </div>

    <div className="details-change-warning">
      <span>
        <WarningCircle size={20} />
      </span>
      <span>
        &nbsp;The final product's gold, diamond, and stone weights may vary
        slightly. If the actual weight is less than the mentioned weight, a
        refund will be issued. If it is higher, the difference will be
        payable.
      </span>
    </div>
  </>
)}



        {/* 💎 Accordion (only renders non-empty panels) */}
        <div className="details-accordion">
          {panels.map((panel, index) => (
            <div
              key={index}
              className={`accordion-item ${openPanel === index ? "open" : ""}`}
            >
              <div className="accordion-header" onClick={() => togglePanel(index)}>
                <h4>{panel.title}</h4>
                <span className="arrow">{openPanel === index ? "−" : "+"}</span>
              </div>
              <div
                className="accordion-body"
                style={{ maxHeight: openPanel === index ? "500px" : "0" }}
              >
                <div className="accordion-content">{panel.content}</div>
              </div>
            </div>
          ))}
        </div>

        <div className="certi-container">
          {/* Certified Quality Gauranteed: */}
          <div className="certis">
            <img src="/images/dgla logo.jpg" className="certificate-logo" />
            <img src="/images/SGL logo.jpg" className="certificate-logo" />
            <img src="/images/IGI logo.png" className="certificate-logo" />
            <img src="/images/bis logo.webp" className="certificate-logo" />
          </div>
        </div>

        <hr className="breakingline" />

        {/* 🛍 Services */}
        <div className="services">
          <ServicesCard
            heading="Buy Back Policy"
            subheading={`${selectedType === "lab grown" ? "40% Diamond Buy back & 100% Exchange" : "90% Diamond Buy Back at current market rate & 100% Exchange"}`}
            icon={<ArrowUUpLeft />}
          />
          <ServicesCard
            heading="Secure Payments"
            subheading="Your payment information is processed securely."
            icon={<Lock />}
          />
          <ServicesCard
            heading="Customer Service"
            subheading="We’re available Mon–Sat for all your questions."
            icon={<Phone />}
          />
        </div>

        <hr className="breakingline" />

        {/* 💎 Related */}
        <div className="suggestionstext font-semibold t3">You may also like</div>
        <div className="container-fluid">
          <YouMayAlsoLike productId={productDetail?._id} categoryid={productDetail._id} gender={productDetail.gender} />
        </div>
      </div>

      {/* 🛒 Add to Cart */}
      <button className="addtocartbt" onClick={addToBag}>
        Add to Bag
      </button>
    </div>
  );
};

export default SingleProductDetails;
